import { useAuthCheckRealmRole, useAuthContext } from '@aibees/shared/auth';
import {
  CreateWorkspace,
  ReloadButton,
  SplashScreen,
} from '@aibees/shared/components';
import { FullScreenBox } from '@aibees/shared/components/full-screen-box';
import { LocalstorageKeys, RealmAccessRole } from '@aibees/shared/definition';
import { useMount } from '@aibees/shared/hooks';
import { Button, Typography } from '@mui/material';
import { createContext, useContext, useState } from 'react';
import { useCreateWorkspaceMutationApi } from '../api';
import {
  WorkspaceContextData as ContextData,
  WorkspaceContextProps as ContextProps,
} from './types';

declare global {
  interface Window {
    tolt_referral?: string;
  }
}

const context = createContext<ContextData>({} as ContextData);

export const { Provider } = context;

const useWorkspaceContext = () => useContext(context);
export const useWorkspace = () => useWorkspaceContext().workspace;
export const useUpdateWorkspace = () => useWorkspaceContext().update;
export const useRefreshworkspace = () => useWorkspaceContext().createWorkspace;

export const WorkspaceProvider = ({ children, value }: ContextProps) => {
  // TODO later user can select workspace after logging in
  const [workspace, setWorkspace] = useState<ContextData['workspace']>();
  // const api = useGetCurrentWorkspaceApi((data) =>
  //   setWorkspace(data.content[0])
  // );

  const { user } = useAuthContext();
  const devModeAccess = useAuthCheckRealmRole(
    [RealmAccessRole.DevelopmentMode],
    true
  );

  const api = useCreateWorkspaceMutationApi();
  const toltReferral = window.tolt_referral;
  const apiCall = () => {
    api
      .mutateAsync({
        name: `${user?.firstName}-${user?.lastName}`,
        ...(toltReferral ? { referral: toltReferral } : {}),
      })
      .then((data) => {
        setWorkspace(data);
      });
  };

  const handleClearDevSettings = () => {
    localStorage.removeItem(LocalstorageKeys.DevSettings);
    window.location.reload();
  };

  useMount(apiCall);

  return (
    <Provider
      value={
        value || { workspace, update: setWorkspace, createWorkspace: apiCall }
      }
    >
      {api.isLoading && <SplashScreen />}

      {api.error && (
        <FullScreenBox flexDirection="column" gap={2}>
          <Typography color="primary" variant="h5">
            Cannot load the workspace
          </Typography>
          <ReloadButton sx={{ width: 'fit-content' }} onReload={apiCall} />
          {devModeAccess && (
            <Button
              size={'small'}
              variant={'outlined'}
              onClick={handleClearDevSettings}
              color={'primary'}
            >
              Clear Dev Settings
            </Button>
          )}
        </FullScreenBox>
      )}

      {workspace && children}

      {api.isLoading && !api.error && !workspace && <CreateWorkspace />}
    </Provider>
  );
};
